import { useState, useCallback } from "react";
import { supabase } from "../supabase/client";
import type { Campaign } from "../types/Campaign";

export function useCampaignStatus() {
  const [updating, setUpdating] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const updateStatus = useCallback(async (campaignId: string, newStatus: Campaign['status']) => {
    setUpdating(true);
    setError(null);

    try {
      const { error } = await supabase
        .rpc('update_campaign_status', {
          campaign_id: campaignId,
          new_status: newStatus
        });

      if (error) {
        throw error;
      }
    } catch (err) {
      setError(err as Error);
    } finally {
      setUpdating(false);
    }
  }, []);

  const assignCSR = useCallback(async (campaignId: string, csrId: string) => {
    setUpdating(true);
    setError(null);

    try {
      const { error } = await supabase
        .from("campaigns")
        .update({ assigned_csr: csrId })
        .eq("id", campaignId);

      if (error) {
        throw error;
      }
    } catch (err) {
      setError(err as Error);
    } finally {
      setUpdating(false);
    }
  }, []);

  return {
    updateStatus,
    assignCSR,
    updating,
    error
  };
}
